import React from "react"
import { Radio, Space } from "@mimber/ui-web"
import { AudienceTargetType } from "@mimber/schema"
import type {
  AudienceSelectorProps,
  AudienceSelectorValue,
} from "./AudienceSelector.types"
import { AudienceTargetedSelects } from "./AudienceTargetedSelects"

export const AudienceSelector: React.FunctionComponent<
  AudienceSelectorProps
> = ({
  value,
  onChange,
  disabled = false,
  "aria-labelledby": ariaLabelledBy,
}) => {
  const targetType = value?.targetType ?? AudienceTargetType.ALL
  const isTargeted = targetType === AudienceTargetType.TARGETED

  const handleTargetTypeChange = (newTargetType: AudienceTargetType) => {
    const next: AudienceSelectorValue = {
      targetType: newTargetType,
      tierTargetIds: value?.tierTargetIds ?? [],
      groupTargetIds: value?.groupTargetIds ?? [],
      roleTargetIds: value?.roleTargetIds ?? [],
      memberTargetIds: value?.memberTargetIds ?? [],
    }
    onChange(next)
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Radio.Group
        value={targetType}
        onChange={(e) => handleTargetTypeChange(e.target.value)}
        disabled={disabled}
        aria-labelledby={ariaLabelledBy}
      >
        <Radio value={AudienceTargetType.ALL}>All Members</Radio>
        <Radio value={AudienceTargetType.TARGETED}>Targeted</Radio>
      </Radio.Group>

      {isTargeted && <AudienceTargetedSelects disabled={disabled} />}
    </Space>
  )
}
